'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _rpMqBreakpoints = require('rp-mq-breakpoints');

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

var _commonMenu = require('./commonMenu');

var _commonMenu2 = _interopRequireDefault(_commonMenu);

var _primaryMenuItemBuilder = require('./primaryMenuItemBuilder');

var _primaryMenuItemBuilder2 = _interopRequireDefault(_primaryMenuItemBuilder);

var _primaryMenuItemActiveNarrow = require('./primaryMenuItemActiveNarrow');

var _primaryMenuItemActiveNarrow2 = _interopRequireDefault(_primaryMenuItemActiveNarrow);

var _rpAnalytics = require('rp-analytics');

var segmentio = _interopRequireWildcard(_rpAnalytics);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Primary Menu
 * @augments CommonMenu
 * @constructor
 */
/**
 * @module navigation/primaryMenu
 * @requires module: navigation/commonMenu
 * @requires module: navigation/primaryMenuItemBuilder
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

function PrimaryMenu() {
    _commonMenu2.default.prototype.constructor.apply(this, arguments);

    this.activeItemNarrow = new _primaryMenuItemActiveNarrow2.default('#primaryCurrent');

    this.itemBuilder = new _primaryMenuItemBuilder2.default();
    this.itemSelector = '.rn-primaryNav__item';

    this.moreItemSelector = '#primaryMoreItem';
    this.moreItemLinkSelector = '#primaryMoreLink';

    this.$moreItem = (0, _jquery2.default)(this.moreItemSelector);
    this.$moreItemLink = (0, _jquery2.default)(this.moreItemLinkSelector);

    this.$secondaryPointer = (0, _jquery2.default)('.rn-secondaryNav__pointer');
    this.$menuButton = (0, _jquery2.default)('#userMenuBtn');
    this.$popover = (0, _jquery2.default)('.rn-primaryNav__popover');
    this.$popoverList = (0, _jquery2.default)('.rn-primaryNav__popover__list');
    this.$parent = (0, _jquery2.default)('body');
    this.$overlay = (0, _jquery2.default)('<div class="ui-overlay" />');
    this.$overlayFrom = (0, _jquery2.default)('.rn-menuBar');

    this.itemClassPreRender = 'rn-primaryNav__item_preRender';
    this.primaryActiveClass = 'rn-primaryNav_active';
    this.menuBarBtnClass = 'rn-menuBar__btn';
    this.menuBarBtnActiveClass = 'rn-menuBar__btn--active';
    this.primaryNavMoreLinkActiveClass = 'rn-primaryNav__more__link--active';
    this.btnMajorClass = 'ui-btn_primary';
    this.linkUiClass = 'ui-link';
    this.morePopoverClass = 'rn-primaryNav__popover_active';

    this.firstClickPrimary = false;
    this.openedPrimary = false;
    this.firstClickMore = false;
    this.openedMore = false;

    this.init();
}
PrimaryMenu.prototype = (0, _create2.default)(_commonMenu2.default.prototype);

/**
 * @inheritdoc
 */
PrimaryMenu.prototype.setActiveItem = function (menuItem) {
    /**
     * Deactivate previously active item
     */
    var activeItem = this.getActiveItem();
    if (activeItem) {
        activeItem.isActive = false;
        activeItem.render();
    }

    /**
     * Skip "More" item, just change a position of pointer
     */
    if (menuItem.$obj.is(this.moreItemSelector)) {
        this.getNavigationContainer().trigger('changePointerPosition.secondaryNav', this._getItemPointerPosition(this.$moreItem));
        return this;
    }

    /**
     * Mark item to active after next render
     */
    _commonMenu2.default.prototype.setActiveItem.call(this, menuItem);

    /**
     * Apply changes to DOM
     */
    menuItem.render();

    this._changeSecondaryPointerPosition();

    return this;
};

/**
 * Bind events
 * @private
 */
PrimaryMenu.prototype._bindEvents = function () {
    var self = this;

    (0, _jquery2.default)(document).ready(this._onDocumentReadyHandler());

    (0, _jquery2.default)(window).on('load', this._onWindowLoadHandler()).on('orientationchange', this._onWindowResizeHandler()).resize(this._onWindowResizeHandler()).on('rpBreakpointsSwitch', this._onSwitchBreakpointsHandler()).on('scroll', this._onWindowScrollHandler());

    (0, _jquery2.default)('.rn-primaryNav').on('click', function (event) {
        var $target = (0, _jquery2.default)(event.target);
        if ($target.hasClass('rn-primaryNav__label')) {
            segmentio.trackNavigationClick((0, _defineProperty3.default)({}, segmentio.TRAIT_SELECTION, $target.text().trim())).then(function () {
                console.log($target.text());
            });
        }
    });

    this.$menuButton.on('click touchstart', function (event) {
        event.preventDefault();
        if (!self.openedPrimary) {
            self.firstClickPrimary = true;
            self._openNavigationPopover();
        }
    });

    this.$obj.on('click touchstart', this.moreItemLinkSelector, function (event) {
        event.preventDefault();
        if (!self.openedMore) {
            self.firstClickMore = true;
            self._openMorePopover();
        }
    });

    this._startMenuSizeTracking();
};

PrimaryMenu.prototype._startMenuSizeTracking = function () {
    var _this = this;

    var handler = this._onWindowResizeHandler();
    var width = this.$obj.width();
    this.interval = setInterval(function () {
        var newWidth = _this.$obj.width();
        if (newWidth !== width) {
            handler();
            width = newWidth;
        }
    }, 50);
};

PrimaryMenu.prototype._stopMenuSizeTracking = function () {
    clearInterval(this.interval);
    this.interval = null;
};

/**
 * @returns {Function}
 * @private
 */
PrimaryMenu.prototype._onDocumentReadyHandler = function () {
    var self = this;

    return function () {
        self.render();
    };
};

/**
 * @returns {Function}
 * @private
 */
PrimaryMenu.prototype._onWindowLoadHandler = function () {
    var self = this;

    return function () {
        self.render();
        self._restoreOverflow();
    };
};

/**
 * @returns {Function}
 * @private
 */
PrimaryMenu.prototype._onWindowResizeHandler = function () {
    var self = this;

    return function (event) {
        self._changeSecondaryPointerPosition.call(self, event);
        self.render();
    };
};

/**
 * @returns {Function}
 * @private
 */
PrimaryMenu.prototype._onSwitchBreakpointsHandler = function () {
    var self = this;

    return function (event) {
        var breakpointCode = event.detail.breakpoint.code;

        if (self.openedPrimary) {
            self._positionOverlay();
        }

        if (!['xn', 'n'].includes(breakpointCode)) {
            if (self.openedPrimary) {
                self._closeNavigationPopover();
            }

            self._renderMoreMenu();
        }

        if (self.openedMore && ['xn', 'n'].includes(breakpointCode)) {
            self._closeMorePopover();
        }
    };
};

/**
 * @returns {Function}
 * @private
 */
PrimaryMenu.prototype._onWindowScrollHandler = function () {
    var self = this;
    return function () {
        if (self.openedPrimary) {
            self._positionOverlay();
        }
    };
};

/**
 * @inheritdoc
 */
PrimaryMenu.prototype.render = function () {
    this.getRenderedItems().removeClass(this.itemClassPreRender);

    _commonMenu2.default.prototype.render.apply(this, arguments);

    if (!['xn', 'n'].includes(_rpMqBreakpoints2.default.current().code)) {
        this._renderMoreMenu();
    }
};

/**
 * Get current visible items number
 * Show items, which fits actual container width
 * Move items, which doesn't fit actual container width, into the 'More' popover
 * Bind click handler to 'More' link
 * @private
 */
PrimaryMenu.prototype._renderMoreMenu = function () {
    var _this2 = this;

    var containerWidth = this.$obj.outerWidth();
    var itemsWidth = 0;
    var moreItems = [];

    this.items.forEach(function (item) {
        var width = item.getItemWidth();
        if (width === 0 || item.$obj.is(_this2.moreItemSelector)) {
            return false;
        }

        itemsWidth += width;
        if (itemsWidth >= containerWidth - _this2.$moreItem.outerWidth()) {
            moreItems.push(item.$obj);
        }
    });

    if (itemsWidth >= containerWidth) {
        this.$popoverList.append(moreItems);
    }

    if (this.$popoverList.find('li').length === 0) {
        this.$moreItem.detach();
    }

    this._changeSecondaryPointerPosition();
};

/**
 * Remove overflow hidden for primary menu container
 * @private
 */
PrimaryMenu.prototype._restoreOverflow = function () {
    this.$obj.addClass('rn-primaryNav_ready');
};

/**
 * Opens Primary Navigation popover on exNarrow and narrow breakpoints
 * @private
 */
PrimaryMenu.prototype._openNavigationPopover = function () {
    if (this.openedPrimary) {
        return;
    }

    this.$obj.addClass(this.primaryActiveClass);
    this.$menuButton.addClass(this.menuBarBtnActiveClass).removeClass(this.menuBarBtnClass);
    this.$menuButton.find('span').text('Close');
    this.$parent.append(this.$overlay);
    this.openedPrimary = true;
    this._positionOverlay();

    (0, _jquery2.default)(document).on('click.rp.navigation.primary touchstart.rp.navigation.primary', this._onClickNavigationPrimaryHandler());
};

/**
 * @private
 */
PrimaryMenu.prototype._positionOverlay = function () {
    this.$overlay.position({
        my: 'left top',
        at: 'left bottom',
        of: this.$overlayFrom.eq(0)
    });
};

/**
 * @returns {Function}
 * @private
 */
PrimaryMenu.prototype._onClickNavigationPrimaryHandler = function () {
    var self = this;

    return function (event) {
        if (self.firstClickPrimary) {
            self.firstClickPrimary = false;
        } else if (!self.$obj[0].contains(event.target)) {
            self._closeNavigationPopover();
        }
    };
};

/**
 * Close Primary Navigation popover on exNarrow and narrow breakpoints
 * @private
 */
PrimaryMenu.prototype._closeNavigationPopover = function () {
    this.$obj.removeClass(this.primaryActiveClass);
    this.$menuButton.removeClass(this.menuBarBtnActiveClass).addClass(this.menuBarBtnClass);
    this.$menuButton.find('span').text('Menu');
    this.$overlay.remove();
    this.openedPrimary = false;

    (0, _jquery2.default)(document).unbind('.rp.navigation.primary');
};

/**
 * @private
 * @param {jQuery} $item
 * @returns {int}
 */
PrimaryMenu.prototype._getItemPointerPosition = function ($item) {
    return $item.offset().left + $item.outerWidth() / 2;
};

/**
 * @private
 */
PrimaryMenu.prototype._changeSecondaryPointerPosition = function () {
    if (!this.$secondaryPointer.is(':visible') || !this.getActiveItem()) {
        return;
    }

    var $currentItem = this.getActiveItem().$obj.children();

    if ($currentItem.closest(this.moreItemSelector).length !== 0) {
        $currentItem = this.$moreItem;
    }

    this.getNavigationContainer().trigger('changePointerPosition.secondaryNav', this._getItemPointerPosition($currentItem));
};

/**
 * Show 'More Sites' popover
 * Change appropriate classes for 'More' button
 * Bind click handler to elements outside the popover
 * @private
 */
PrimaryMenu.prototype._openMorePopover = function () {
    if (this.openedMore) {
        return;
    }

    this._restoreOverflow();

    this.$popover.addClass(this.morePopoverClass);
    this.$moreItemLink.addClass(this.primaryNavMoreLinkActiveClass).removeClass(this.linkUiClass);
    this.openedMore = true;

    (0, _jquery2.default)(document).on('click.rp.navigation.more touchstart.rp.navigation.more', this._onClickNavigationMoreHandler());
};

PrimaryMenu.prototype._onClickNavigationMoreHandler = function () {
    var self = this;

    return function (event) {
        if (self.firstClickMore) {
            self.firstClickMore = false;
        } else if (!self.$popover[0].contains(event.target)) {
            self._closeMorePopover();
        }
    };
};

/**
 * Hide 'More Sites' popover
 * Change appropriate classes for 'More' button
 * Unbind click handler from elements outside the popover
 * @private
 */
PrimaryMenu.prototype._closeMorePopover = function () {
    this.$popover.removeClass(this.morePopoverClass);
    this.$moreItemLink.removeClass(this.primaryNavMoreLinkActiveClass).addClass(this.linkUiClass);
    this.openedMore = false;

    (0, _jquery2.default)(document).unbind('.rp.navigation.more');
};

exports.default = PrimaryMenu;


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/navigation/primaryMenu.js
// module id = 1511
// module chunks = 0